<template>
  <div
    class="flex flex-nowrap place-items-start mt-5"
    :class="[
      {
        'flex-row': side_menu_type == 'side',
        'flex-col': side_menu_type != 'side',
      },
    ]"
  >
    <div
      v-if="side_menu_type == 'side'"
      class="w-[180px] mr-5 shrink-0 border border-fh-gray"
    >
      <div class="side_menu side_menu_root">{{ title }}</div>
      <side-sub-menu />
    </div>
    <div v-else class="mx-auto w-full mb-5">
      <div class="top_menu top_menu_root" @click="toggleTopMenu">
        {{ title }}
        <i v-if="showTopMenu" class="pi pi-angle-down"></i
        ><i v-else class="pi pi-angle-right"></i>
      </div>
      <transition name="p-toggleable-content">
        <side-sub-menu v-show="showTopMenu" />
      </transition>
    </div>
    <div class="w-full">
      <header><slot name="header" /></header>

      <slot />
    </div>
  </div>
</template>

<script>
import SideSubMenu from "./SideMenu";

export default {
  components: {
    SideSubMenu,
  },
  props: {
    title: {
      type: String,
      default: "功能選單",
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      showTopMenu: false,
    };
  },
  computed: {
    side_menu_type() {
      if (this.windowWidth >= 640) return "side";
      return "dropdown";
    },
  },
  methods: {
    toggleTopMenu() {
      this.showTopMenu = !this.showTopMenu;
    },
  },
  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
};
</script>

<style lang="postcss">
.top_menu_root {
  @apply w-full px-4 py-2 bg-fh-blue text-white;
}

.side_menu_root {
  @apply px-4 py-2 bg-fh-blue text-white;
}

.side_menu li {
  @apply px-4 py-2 border-t border-fh-gray-border;
}

.side_menu_active {
  @apply bg-fh-gray-bg;
}

.side_menu_inactive {
  @apply bg-fh-gray-bg;
}

.side_menu_inactive:hover {
  @apply bg-fh-gray-light;
}

.active {
  @apply border-b;
}

header {
  @apply text-2xl mt-1 mb-4;
}

.form {
  @apply w-full mt-1 pt-3 flex flex-row justify-start items-center;
}

.form-title {
  @apply mt-1 w-32;
}

.form-element {
  @apply mt-1 flex flex-row items-center content-start gap-4;
}

.form-element-subs {
  @apply mt-1 flex flex-col content-start gap-1;
}

.form-element-sub {
  @apply mt-1 flex flex-row items-center gap-1;
}
</style>